import { makeStyles, Theme } from '@material-ui/core'

const buildStyles = makeStyles((theme: Theme) => ({
  optionCard: (props: { isMobile: boolean }) => {
    return {
      width: '100%',
      display: 'flex',
      padding: '5px',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      height: props.isMobile ? '80px' : '150px',
      background: '#ffffff',
      boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.7)',
      borderRadius: '20px',
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '0px 5px 25px rgba(0, 0, 0, 0.8)',
      },
    }
  },

  voucherConditionLabel: {
    marginTop: '50px',
    fontSize: '16px',
  },

  star: {
    width: '15px',
    height: '15px',
    marginRight: '15px',
    minWidth: '15px',
    minHeight: '15px',
  },

  bigStar: {
    margin: '10px 15px',
    width: '34px',
    height: '34px',
  },

  optionLabel: {
    position: 'relative',
    fontWeight: 400,
    fontSize: '38px',
    textAlign: 'center',
    color: '#000000',
  },

  voucherCard: {
    background: '#edfbfe',
  },
}))

export default buildStyles
